export enum SurveyQuestionTypeEnum {
    Text,
    YesNo,
    List,
    Image,
    ImageFile,
    Video,
    VideoFile
}
